import Image from 'next/image';
import clsx from 'clsx';
import { motion } from 'framer-motion';

export default function PromotionHero({
  promotion,
  onClick,
}: {
  promotion: any;
  onClick: () => void;
}) {
  const {
    discount: originalDiscount,
    name,
    banner,
    banner_settings: { headline, sub_headline, primary_color, secondary_color },
  } = promotion;
  const discount = Number(originalDiscount * 100).toFixed();

  return (
    <div className="overlap mb-8 h-[70dvh] items-end overflow-hidden bg-white md:h-[900px] md:items-center">
      <div className="mx-auto mb-4 w-full max-w-7xl px-4 md:mb-0 md:px-2">
        <div
          className={clsx(
            'relative z-10 mx-auto max-w-[576px] rounded-3xl p-10 text-white shadow-2xl shadow-black/50 md:mt-72 lg:m-0'
          )}
          style={{ backgroundColor: `${primary_color}` }}
        >
          <motion.h4
            className="mb-4 font-sans text-xl font-black text-white md:text-2xl"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            {name}
          </motion.h4>
          <motion.h2
            className="mb-6 text-4xl text-white md:text-5xl"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            {headline}
          </motion.h2>

          <motion.p
            className="text-md mb-8 font-medium text-white md:text-xl"
            initial={{ opacity: 0, scale: 0.2 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {sub_headline}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <button
              onClick={onClick}
              className="text-true-black w-full rounded-full p-2 font-bold transition-all duration-300 hover:bg-white md:w-auto"
              style={{ backgroundColor: `${secondary_color}` }}
            >
              <span className="px-2 font-bold">Get {discount}% off</span>
            </button>
          </motion.div>
        </div>
      </div>
      <Image
        src={banner.url}
        alt="Promotion Hero"
        width={1730}
        height={900}
        className="banner-mask pointer-events-none h-full w-full object-cover"
        priority
      />
    </div>
  );
}
